import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const getCode = (sign) => {
    console.log(baseUrl,'ces1234')
    return request({
        url: `${baseUrl}/joins-login/v1/systemLogin/${sign}`,
        method: 'GET'
    })
}

export const systemLogin = (data) => {
    return request({
        url: `${baseUrl}/joins-login/v1/systemLogin`,
        method: 'post',
        data: data
    })
}

export const refeshToken = () => {
    return request({
        url: `${baseUrl}/joins-login/v1/systemLogin/refresh`,
        method: 'PUT'
    })
}

export const logout = () =>{
    return request({
        url: `${baseUrl}/joins-login/v1/systemLogin/logout`,
        method: 'PUT'
    })
}

export const FgtPwdCode = (mobile) =>{
    return request({
        url: `${baseUrl}/joins-login/v1/user/send/forget_password/${mobile}?clientType=JOINS_AGENT`,
        method: 'GET',
    })
}

export const validFgtPwdCode = (data) =>{
    data = parseParam(data)
    return request({
        url: `${baseUrl}/joins-login/v1/user/repeat_password/valid?`+ data,
        method: 'GET',
    })
}

export const resetPwd = (data) =>{
    return request({
        url: `${baseUrl}/joins-login/v1/user/change_password`,
        method: 'PUT',
        data:data
    })
}

export const changePassword = (data) =>{
    const params = parseParam(data)
    return request({
        url: `${baseUrl}/joins-login/v1/systemLogin/changePassword?${params}`,
        method: 'PUT',
        ContentType: 'application/x-www-form-urlencoded'
    })
}